exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-ma-index-js": () => import("./../../../src/pages/ma/index.js" /* webpackChunkName: "component---src-pages-ma-index-js" */),
  "component---src-pages-ms-index-js": () => import("./../../../src/pages/ms/index.js" /* webpackChunkName: "component---src-pages-ms-index-js" */),
  "component---src-pages-pdp-index-js": () => import("./../../../src/pages/pdp/index.js" /* webpackChunkName: "component---src-pages-pdp-index-js" */)
}

